import { createUseQuery } from 'api/common/createUseQuery'
import { createLazyQuery } from 'hooks/useLazyQuery'

import { AwardsAttachments } from '../../types/AwardsAttachments'
import { fetchAttachments } from '../fetchers/fetchAttachments'

export const useAttachments = (slug: string, options = {}) => {
  const useQuery = createUseQuery({
    queryKey: ['ATTACHMENTS', slug],
    fetcher: () => fetchAttachments(slug),
    selector: res => res?.data ?? ({} as AwardsAttachments),
  })

  const query = useQuery(options)

  return {
    data: query.data,
    error: query.error,
    isLoading: query.isLoading,
  }
}

export const useAttachmentsLazy = createLazyQuery({
  queryKey: [Math.random.toString()],
  fetcher: fetchAttachments,
  selector: (res: any) => res?.data ?? [],
})
